// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileHeader_container__bJpQ1","menu":"MobileHeader_menu__4ozNZ","lenseBtn":"MobileHeader_lenseBtn__4ZZ8K","logo":"MobileHeader_logo__jG35X"};